export default __webpack_public_path__ + "static/media/1FA and bank.1529c389.png";